module.exports = __webpack_public_path__ + "static/media/9DESA13.a96fa328.jpg";